import { memo } from 'react';
import { JoinReactNodes } from 'src/common/JoinReactNodes.tsx';

type Props = {
    value: string;
}

export const ValveFilterTooltip = memo(({ value }: Props) => {
    const content = value.split(',')
        .map((name) => (
            <div className="vss-valves-tooltip-value__row">
                <p className="vss-valves-tooltip-value__label">
                    {name}
                </p>
            </div>
        ));
    return (<div className="vss-valves-tooltip-value"><JoinReactNodes separator="" content={content}/></div>);
});
